<template>
  <div class="regulations-page">
    <div v-if="loading" class="state-loading">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
    <template v-else>
      <div class="content-wrap">
        <div
          v-if="match.accessory"
          class="accessory-bar"
        >
          <div class="accessory-left">
            <van-icon name="orders-o" class="accessory-icon" />
            <span class="accessory-name">{{ match.accessory }}</span>
          </div>
          <van-button
            size="small"
            type="info"
            round
            class="accessory-btn"
            @click="downLoadAccessory"
          >
            下载
          </van-button>
        </div>
        <div
          v-if="regulationsHtml"
          class="regulations-rich"
          v-html="regulationsHtml"
        />
        <van-empty
          v-if="!match.accessory && !regulationsHtml"
          description="暂无竞赛规程"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Loading, Empty, Icon } from 'vant'
Vue.use(Button).use(Loading).use(Empty).use(Icon)
import { getBMUnionMatch } from '@/api/match'

export default {
  data() {
    return {
      unionMatchId: '',
      loading: true,
      match: {},
      regulationsHtml: ''
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.fetchMatch()
  },
  methods: {
    fetchMatch() {
      if (!this.unionMatchId) {
        this.loading = false
        return
      }
      const preview = this.$route.query.preview || 0
      getBMUnionMatch({ unionMatchId: this.unionMatchId, preview })
        .then((res) => {
          const data = (res && res.data) || {}
          this.match = data.match || {}
          this.regulationsHtml = (this.match && this.match.regulations) || ''
          document.title = this.match.chineseName
            ? `${this.match.chineseName}-竞赛规程`
            : '竞赛规程'
        })
        .catch(() => {
          this.match = {}
          this.regulationsHtml = ''
        })
        .finally(() => {
          this.loading = false
        })
    },
    downLoadAccessory() {
      const name = this.match.accessory
      if (!name) return
      window.open(`https://images.snsports.cn/${name}`)
    }
  }
}
</script>

<style scoped lang="scss">
.regulations-page {
  min-height: 100vh;
  background: #f6f6f8;
  box-sizing: border-box;
}

.state-loading {
  padding: 48px 0;
  display: flex;
  justify-content: center;
}

.content-wrap {
  // padding: 12px 16px 24px;
  box-sizing: border-box;
}

.accessory-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ebf1fe;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  min-height: 60px;
  box-sizing: border-box;
}

.accessory-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  margin-right: 8px;
}

.accessory-icon {
  font-size: 28px;
  color: #337ecc;
  margin-right: 8px;
  flex-shrink: 0;
}

.accessory-name {
  font-size: 14px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.accessory-btn {
  width: 52px;
  flex-shrink: 0;
}

.regulations-rich {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  word-break: break-word;
}
/* 后台富文本内容 */
.regulations-rich ::v-deep img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}
.regulations-rich ::v-deep p {
  margin: 0.5em 0;
}
.regulations-rich ::v-deep ul,
.regulations-rich ::v-deep ol {
  padding-left: 1.2em;
  margin: 0.5em 0;
}
</style>
